import system from './system'
import table from './table'
import value from './value'
import mask from './mask'
import access from './access'
import dashboard from './dashboard'

export default {
  system,
  table,
  value,
  mask,
  access,
  dashboard
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/pt-br.js